import React, { useState } from 'react'
import { Stepper } from 'react-form-stepper';
import './ServicesForm1.css'


function Servicesinfo({ services, setservices, soletrader, setsoletrader, privatedriver, setprivatedriver, deliverydriver, setdeliverydriver, cis, setcis
    , taxidriver, settaxidriver, onlineseller, setonlineseller, other, setother, propertyaccount, setpropertyaccount, companyname, 
    setcompanyname, companynumber, setcompanynumber, paye, setpaye, message, setmessage, formSubmitHondler, loading, setstep, step }) {

  

    const servicesfun = (e) => {
        setservices(e.target.value)
        setsoletrader('');
        setprivatedriver('');
        setdeliverydriver('');
        setcis('');
        settaxidriver('');
        setonlineseller('');
        setother('');
        setpropertyaccount('');
        setcompanyname('');
        setcompanynumber('');
        setpaye('');
    }

    // const submithandle = (e) => {
    //     e.preventDefault()
    //     setstep(step + 1)
        
    // }



    return (
        <div>
            <div className='stepper-div1'>
                {/* <Stepper activeStep={1} steps={[{ label: 'Personal Detail' }, { label: 'Services' }, { label: 'Complete' }]} styleConfig={{
                    activeBgColor: '#485CE1',
                    activeTextColor: '#fff',
                    inactiveBgColor: '#fff',
                    inactiveTextColor: '#3033B5',
                    completedBgColor: '#2729a1',
                    completedTextColor: '#fff',
                    size: '3em'

                }} className={'stepper'}
                    stepClassName={'stepper__step'}>
                </Stepper>     */}

                <div className='stepper-main-div1'>
                    <div className='stepper-main-div2'> 
                    <div className='stepper-main-div3'>
                        <button className='stepper-main-btn1-complete'><span>1</span></button>
                            <div className= 'stepper-main-div4'>
                                <span>Personal Detail</span>
                            </div>
                        </div>
                         </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1-active'><span>2</span></button>
                            <div className='stepper-main-div4'>
                                <span>Services</span>
                            </div>
                        </div>
                    </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1'><span>3</span></button>
                            <div className='stepper-main-div4'>
                                <span>Complete</span>
                            </div>
                        </div>
                    </div>
                </div>



                <form className="service-contact-form col-12" onSubmit={formSubmitHondler} >
                    <div class="row">
                        <div class=" col-12">
                            <label className='form-labels' >Services<span>*</span></label>
                            <select class="form-control contact-input-field5" value={services} name='services' onChange={servicesfun}>
                                <option selected disabled>Choose Services ...</option>
                                <option value="Self Assesment">Self Assesment</option>
                                <option value="Property Accounts">Property Accounts</option>
                                <option value="Limited Accounts">Limited Accounts</option>
                                <option value="Paye">Paye</option>
                            </select>
                        </div>

                        <div className={`${services == "Self Assesment"
                            ? "col-lg-6 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Sole Trader<span>*</span></label>

                            <input
                                type="text"
                                name="soletrader"
                                class="form-control contact-input-field5"
                                placeholder="Sole Trader"
                                onChange={(e) => setsoletrader(e.target.value)}
                                value={soletrader}
                            />
                        </div>

                        <div className={`${services == "Self Assesment"
                            ? "col-lg-6 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Private Hire Driver<span>*</span></label>

                            <input
                                type="text"
                                name="privatedriver"
                                class="form-control contact-input-field5"
                                placeholder="Private Hire Driver"
                                onChange={(e) => setprivatedriver(e.target.value)}
                                value={privatedriver}
                            />
                        </div>

                        <div className={`${services == "Self Assesment"
                            ? "col-lg-6 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Delivery Driver<span>*</span></label>

                            <input
                                type="text"
                                name="deliverydriver"
                                class="form-control contact-input-field5"
                                placeholder="Delivery Driver"
                                onChange={(e) => setdeliverydriver(e.target.value)}
                                value={deliverydriver}
                            />
                        </div>

                        <div className={`${services == "Self Assesment"
                            ? "col-lg-6 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>CIS<span>*</span></label>

                            <input
                                type="text"
                                name="cis"
                                class="form-control contact-input-field5"
                                placeholder="CIS"
                                onChange={(e) => setcis(e.target.value)}
                                value={cis}
                            />
                        </div>
                        <div className={`${services == "Self Assesment"
                            ? "col-lg-6 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Taxi Driver<span>*</span></label>

                            <input
                                type="text"
                                name="taxidriver"
                                class="form-control contact-input-field5"
                                placeholder="Taxi Driver"
                                onChange={(e) => settaxidriver(e.target.value)}
                                value={taxidriver}
                            />
                        </div>
                        <div className={`${services == "Self Assesment"
                            ? "col-lg-6 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Online Seller<span>*</span></label>

                            <input
                                type="text"
                                name="onlineseller"
                                class="form-control contact-input-field5"
                                placeholder="Online Seller"
                                onChange={(e) => setonlineseller(e.target.value)}
                                value={onlineseller}
                            />
                        </div>

                        <div className={`${services == "Self Assesment"
                            ? "col-lg-6 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Other<span>*</span></label>

                            <input
                                type="text"
                                name="other"
                                class="form-control contact-input-field5"
                                placeholder="Other"
                                onChange={(e) => setother(e.target.value)}
                                value={other}
                            />
                        </div>

                        <div className={`${services == "Property Accounts"
                            ? "col-lg-12 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Property Accounts<span>*</span></label>

                            <input
                                type="text"
                                name="propertyaccount"
                                class="form-control contact-input-field5"
                                placeholder="Property Accounts"
                                onChange={(e) => setpropertyaccount(e.target.value)}
                                value={propertyaccount}
                            />
                        </div>

                        <div className={`${services == "Limited Accounts"
                            ? "col-lg-6 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Company Name<span>*</span></label>

                            <input
                                type="text"
                                name="companyname"
                                class="form-control contact-input-field5"
                                placeholder="Company Name"
                                onChange={(e) => setcompanyname(e.target.value)}
                                value={companyname}
                            />
                        </div>

                        <div className={`${services == "Limited Accounts"
                            ? "col-lg-6 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Company Number<span>*</span></label>

                            <input
                                type="number"
                                name="companynumber"
                                class="form-control contact-input-field5"
                                placeholder="Company Number"
                                onChange={(e) => setcompanynumber(e.target.value)}
                                value={companynumber}
                            />
                        </div>

                        <div className={`${services == "Paye"
                            ? "col-lg-12 col-12 mt-lg-5 mt-4 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Paye<span>*</span></label>

                            <input
                                type="text"
                                name="paye"
                                class="form-control contact-input-field5"
                                placeholder="Paye"
                                onChange={(e) => setpaye(e.target.value)}
                                value={paye}
                            />
                        </div>



                        <div className='col-12 mt-lg-5 mt-4 '>
                            <label className='form-labels'>Message<span>*</span></label>

                            <textarea name="message" value={message} onChange={(e) => setmessage(e.target.value)} id="" cols="20" rows="5" class="form-control contact-input-field5"></textarea>
                        </div>
                        <div className='d-flex w-100 justify-content-end pr-2'>
                            <div className="mt-5 contact-us-btn-div2">
                                <button
                                    // type="submit"
                                    onClick={(()=>{setstep(step-1)})}
                                    className="ml-sm-auto mx-sm-0 mx-auto contactus-form-btn4"
                                >
                                    Back

                                </button>
                            </div>

                            <div className="mt-5 contact-us-btn-div2 ml-4">
                                <button
                                    type="submit"
                                    className="ml-sm-auto mx-sm-0 mx-auto contactus-form-btn4 "
                                >
                                    {loading ? "Please Wait..." : 'Submit'}
                                </button>
                            </div>
                        </div>
                       
                              
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Servicesinfo
